import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Grid, useMediaQuery } from "@mui/material";

// Common Components
import Login from "../features/auth/containers/LoginContainer";

// User Components
import Home from "../features/public/profile/PublicProfileContainer";
import Profile from "../features/admin/userProfile/Containers/ProfileCont.js"; // Legacy?

// Client Components
import AdminLayout from "../features/admin/components/AdminLayout";
import AddLink from "../features/admin/links/ManageLinks/containers/SocialMediaCon.js";
import EditLinks from "../features/admin/links/ManageLinks/containers/editProfileCon.js";
import BadReview from "../features/admin/links/BadReview/containers/BadReviewCon.js";
import AdminProfile from "../features/admin/profile/containers/AdminProfileCont.js";
import EditAdminProfile from "../features/admin/profile/containers/EditAdminProfileCont.js";
import ChangePassword from "../features/admin/userProfile/Containers/ChangePasswordCont.js";


export default function Routers({ login, onLogout }) {
  const isMdUp = useMediaQuery("(min-width:768px)");

  let body;

  if (login.isHome) {
    body = (
      <Grid container>
        <Grid item xs={12}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/:username" element={<Home />} />
          </Routes>
        </Grid>
      </Grid>
    );
  } else {
    switch (localStorage.getItem("type")) {
      case "SA":
        body = (
          <AdminLayout login={login} onLogout={onLogout}>
            <Routes>
              <Route path="/" element={<AddLink />} />
              <Route path="/profile" element={<AdminProfile />} />
              <Route path="/editProfile" element={<EditAdminProfile />} />
              <Route path="/edit-links" element={<EditLinks />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/badfeedback" element={<BadReview />} />
              <Route path="/adminprofile" element={<AdminProfile />} />
            </Routes>
          </AdminLayout>
        );
        break;
      default:
        body = (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/:username" element={<Home />} />
          </Routes>
        );
        break;
    }
  }

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {body}
    </Router>
  );
}
